import { type DomainAccessControlConfig } from 'domains/retailer-collections/utils/domain/accessControl'
import { Flipper } from 'domains/retailer-collections/access-control/flippers'

export const retailerCollectionsAccessControl: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.retailerCollections],
}

export const retailerCollectionsV1NavigationItem: DomainAccessControlConfig = {
  warehouseFlippers: [Flipper.retailerCollections],
  notWarehouseFlippers: [Flipper.retailerCollectionsV2Preview],
}
